import type { SigninRedirectArgs } from 'oidc-client-ts';

export type LoginMethod = 'feishu' | 'account';

export function buildSigninRedirectArgs(method: LoginMethod, returnTo: string): SigninRedirectArgs {
  return {
    state: { returnTo },
    ...(method === 'feishu' ? { extraQueryParams: { kc_idp_hint: 'feishu' } } : {}),
  };
}
